import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateReminderInput, Reminder, ReminderHistoryEntry } from '@avslack/shared';
import { apiFetch } from '../lib/api';

/**
 * Emlekeztetok.
 *
 * Nem uzenet: nincs csatornaja, es nem a folyamban jelenik meg. Egyetlen
 * dolga van - a megadott idopontban felhivja magara a figyelmet, akkor is, ha
 * a cimzett nemitva van.
 */
/**
 * A sajat emlekeztetok - vagy adminkent mindenkie.
 *
 * A `mind` csak adminnal hat: a szerver ellenorzi a jogot, es sima
 * felhasznalonal a sajat listat adja vissza. Igy a felulet nem tud tobbet
 * mutatni, mint amennyit szabad.
 */
export function useReminders(all = false) {
  return useQuery({
    queryKey: ['reminders', all],
    queryFn: () =>
      apiFetch<{ reminders: Reminder[]; all: boolean }>(
        `/api/reminders${all ? '?mind=1' : ''}`,
      ).then((r) => r.reminders),
    staleTime: 30_000,
  });
}

/**
 * AZ ELOZMENY: mi szolt nekem, es mikor.
 *
 * Nem ugyanaz, mint a `useReminders`: az a FUGGOBEN levo emlekeztetokrol
 * szol, ez a MEGTORTENT alkalmakrol. Egy ismetlodo emlekezteto egyetlen sor
 * amott, es sok sor itt.
 */
export function useReminderHistory(limit = 50) {
  return useQuery({
    queryKey: ['reminders', 'history', limit],
    queryFn: () =>
      apiFetch<{ entries: ReminderHistoryEntry[]; unacked: number }>(
        `/api/reminders/history?limit=${limit}`,
      ),
    staleTime: 30_000,
  });
}

/**
 * "Megvan" - es a visszavonasa.
 *
 * A valasz utan az EGESZ emlekezteto-agat frissitjuk: a lista es a jelveny
 * ugyanabbol a szambol el, es egy elmaradt frissites utan a felhasznalo egy
 * mar kipipalt tetelt latna nyitottkent.
 */
export function useAckReminder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ deliveryId, acked }: { deliveryId: string; acked: boolean }) =>
      apiFetch(`/api/reminders/deliveries/${deliveryId}/ack`, {
        method: 'POST',
        body: JSON.stringify({ acked }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['reminders'] }),
  });
}

export function useUpdateReminder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      ...patch
    }: {
      id: string;
      text?: string;
      remindAt?: string;
      targetIds?: string[];
      groupIds?: string[];
      repeat?: CreateReminderInput['repeat'];
    }) =>
      apiFetch<{ reminder: Reminder }>(`/api/reminders/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(patch),
      }).then((r) => r.reminder),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['reminders'] }),
  });
}

export function useCreateReminder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateReminderInput) =>
      apiFetch<{ reminder: Reminder }>('/api/reminders', {
        method: 'POST',
        body: JSON.stringify(input),
      }).then((r) => r.reminder),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['reminders'] }),
  });
}

export function useCancelReminder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reminderId: string) =>
      apiFetch(`/api/reminders/${reminderId}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['reminders'] }),
  });
}
